/**
 *
 * @module purchaseClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class PurchaseClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the PurchaseClient.
 *
 */
export default class PurchaseClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/purchase/purchaseClientConfiguration.js